import React, { useState } from 'react';
import { PlayIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { useUi } from '../../contexts/UiContext';
import { TaskTemplate } from '../../types/family';
import { isDoneStatus } from '../../utils/progress';
import { Button } from '../ui/Button';
export function TimerPicker() {
  const {
    myTemplates,
    getOcc,
    minutesToday
  } = useAppState();
  const {
    requestTimerStart
  } = useUi();
  const [freeLabel, setFreeLabel] = useState('');
  const open = myTemplates.filter(t => !isDoneStatus(getOcc(t.id).status) && getOcc(t.id).status !== 'v_pregledu');
  const solo = open.filter(t => t.assigneeIds.length === 1).sort((a, b) => Number(b.timed) - Number(a.timed));
  const shared = open.filter(t => t.assigneeIds.length > 1);
  const renderList = (items: TaskTemplate[]) => <ul className="divide-y divide-line overflow-hidden rounded-2xl border border-line" data-id="element-1100" data-mp="1j98abj7wgokv">
      {items.map(t => <li key={t.id} data-id="element-1101" data-mp="1o68etpp3pj9v">
          <button type="button" onClick={() => requestTimerStart({
        templateId: t.id
      })} className="flex min-h-[52px] w-full items-center gap-3 px-3 py-2 text-left transition-colors duration-150 hover:bg-canvas focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-accent" data-id="element-1102" data-mp="11caod3sxs91b">
            <span className="min-w-0 flex-1" data-id="element-1103" data-mp="nj2yphof1nm9">
              <span className="block font-bold" data-id="element-1104" data-mp="imcj0vgiwu1d">{t.title}</span>
              {t.targetMinutes && <span className="text-xs tabular-nums text-muted" data-id="element-1105" data-mp="dmq3ugh4x3px">
                  {minutesToday(t.id)}/{t.targetMinutes} min danes
                </span>}
            </span>
            <PlayIcon className="h-4 w-4 shrink-0 text-accent" fill="currentColor" aria-hidden="true" data-id="element-1106" data-mp="4mtfyh2kk8vx" />
          </button>
        </li>)}
    </ul>;
  return <div className="space-y-5" data-id="element-1107" data-mp="22zl9z3j0y3gh">
      <section data-id="element-1108" data-mp="1z02pg8v47ue6">
        <h3 className="mb-2 text-sm font-extrabold" data-id="element-1109" data-mp="1z1dqi0x6eo1l">Moje naloge danes</h3>
        {solo.length > 0 ? renderList(solo) : <p className="text-sm text-muted" data-id="element-1110" data-mp="3shi6r6o9fbri">Vse tvoje naloge so opravljene.</p>}
      </section>
      {shared.length > 0 && <section data-id="element-1111" data-mp="16gnma3yfy8p">
          <h3 className="mb-2 text-sm font-extrabold" data-id="element-1112" data-mp="3jid53rhej2b4">Skupne</h3>
          {renderList(shared)}
        </section>}
      <section data-id="element-1113" data-mp="3njgk6brmkuba">
        <h3 className="mb-1 text-sm font-extrabold" data-id="element-1114" data-mp="3nl03kb8kvlha">Prevzete</h3>
        <p className="text-sm text-muted" data-id="element-1115" data-mp="f4erglkngc9y">Ko boš prevzel izvedbo drugega člana, bo tukaj (prevzemi pridejo v koraku 4).</p>
      </section>
      <section data-id="element-1116" data-mp="k1yheiqpmdhq">
        <h3 className="mb-2 text-sm font-extrabold" data-id="element-1117" data-mp="k2glu2nizy0q">Prosta dejavnost</h3>
        <form className="flex gap-2" onSubmit={e => {
        e.preventDefault();
        if (freeLabel.trim()) requestTimerStart({
          freeLabel: freeLabel.trim()
        });
      }} data-id="element-1118" data-mp="62faft9mx870">
          <label htmlFor="free-activity" className="sr-only" data-id="element-1119" data-mp="2qs4nq1uowlxl">
            Opis proste dejavnosti
          </label>
          <input id="free-activity" value={freeLabel} onChange={e => setFreeLabel(e.target.value)} placeholder="npr. Risanje" className="h-11 min-w-0 flex-1 rounded-xl border border-line bg-surface px-3 text-sm focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/30" data-id="element-1120" data-mp="2vu3or52yj6rd" />
          <Button type="submit" disabled={!freeLabel.trim()} data-id="element-1121" data-mp="2salcdxakmkfa">
            Začni
          </Button>
        </form>
        <p className="mt-2 text-xs text-muted" data-id="element-1122" data-mp="24m277qmtinrf">
          Prosta dejavnost se zapiše v dnevnik časa. Ne prinese točk in ne ustvari nove obveznosti.
        </p>
      </section>
    </div>;
}